import { useEffect } from 'react';

import { $getSelection, $isRangeSelection, PASTE_COMMAND } from 'lexical';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { cleanUnicodeCharacters } from '../../utils';

export const PasteCleanupPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event: ClipboardEvent) => {
        const clipboardData = event.clipboardData;
        if (!clipboardData) return false;

        let text = clipboardData.getData('text/plain');
        if (!text) return false;

        const cleanText = cleanUnicodeCharacters(text);

        editor.update(() => {
          const selection = $getSelection();

          if ($isRangeSelection(selection)) {
            selection.insertText(cleanText);
          }
        });

        event.preventDefault();
        return true;
      },
      1,
    );
  }, [editor]);

  return null;
};
